module.exports = __webpack_public_path__ + "static/assets/6ce74a34ca9f39761f55e4a092908782.png";